module.exports = __webpack_public_path__ + "img/softwareLogo3.03e9efd9.png";